import React from 'react';
import { Button } from '../../../common';
import styles from './styles/title.module.scss';
import { Tag } from 'antd';
import dayjs from 'dayjs';

function Title({ consumer }) {
    return (
        <div className={styles.titleContainer}>
            <div className={styles.titleLeft}>
                <Tag color={consumer.isActive ? 'green' : 'red'}>{consumer.isActive ? 'Active' : 'Inactive'}</Tag>
                <p className={styles.titleLeftName}>{consumer.name}</p>
                <p className={styles.titleLeftSince}>Clockout customer since {dayjs(consumer.createdAt).format('MMM D, YYYY')}</p>
            </div>
            <div className={styles.titleRight}>
                <Button text="Restrict Access" color="#F34131" />
            </div>
        </div>
    );
}

export default Title;
